import { redirectToUrl } from "~/utils/url/urlUtils";

export function sendRailResetConfigurator(productCode: string): void {
  redirectToUrl(`/rails/${productCode}/railsConfiguratorPage/reset`);
}
